import styled from '@emotion/styled/macro';
import vars from '@variables';
import { defineResponsiveGridColumns } from '@utils/utils';

export const MailchimpSignUpFormContainer = styled.div`
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: ${defineResponsiveGridColumns(4)};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(8)};
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }

  #mc_embed_shell {
    grid-column: col1-start/col4-end;

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col2-start/col7-end;
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: col3-start/col10-end;
    }
  }

  #mc_embed_signup form {
    .indicates-required {
      color: red;
      text-align: right;
    }
    font-size: 1.6rem;
    .mc-field-group {
      margin: 10px 0 !important;
    }

    label {
      color: #2f2f46;
      font-weight: bold;
      display: block;
      padding-bottom: 6px;
    }
    input[type='text'],
    input[type='email'] {
      background-color: #ffffff;
      border: 2px solid #c9c9c9;
      border-radius: 3px;
      display: inline-block;
      margin: 0 0 24px;
      min-height: 36px;
      min-width: 50px;
      padding: 0 0.4em;
      vertical-align: middle;
      width: 100%;
      font-size: 1.6rem;
      line-height: 18px;
      font-weight: normal;
      cursor: pointer;
    }
    select {
      background: #ffffff
        url(https://cdn-images.mailchimp.com/product/icons/signup-sprite.png)
        no-repeat right -296px;
      padding: 5px 8px;
      -webkit-appearance: none;
      font-size: 1.6rem;
      border: 2px solid #c9c9c9;
      border-radius: 3px;
      display: inline-block;
      margin: 0 0 24px;
      min-height: 36px;
      min-width: 345px;
      padding: 0 0.4em;
      vertical-align: middle;
      width: 50%;
      cursor: pointer;
    }
    ul {
      list-style: none;
      margin-bottom: 24px;
      padding: 0;
    }
    ul li {
      position: relative;
      display: flex;
      list-style-type: none;
      margin: 0;
      padding: 1rem 0 0.5rem 0;
    }

    .checkbox label {
      padding-left: 36px;
      padding-top: 3px;
      padding-bottom: 3px;
      margin-bottom: 6px;
      font-size: 1.6rem;
      font-weight: normal;
      position: relative;
      line-height: 24px;
      flex: 0 0 auto;
      max-width: 100%;
      text-align: left;
      cursor: pointer;
    }
    .checkbox input {
      position: absolute;
      left: 0;
      width: 24px;
      height: 24px;
      overflow: hidden;
      margin: 0;
      padding: 0;
      outline: 0;
      cursor: pointer;
      appearance: none;
      background-color: #fff;
      border: 2px solid #2f2f46;
      border-radius: 4px;
    }

    .checkbox input:checked {
      background-color: #5d5d5d;
      border-radius: 5px;
      border-color: #5d5d5d;
      background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%20viewBox%3D%270%200%2014%2012%27%3E%3Cpolygon%20fill%3D%27%23FFFFFF%27%20points%3D%279.875%2013.91%2016.954%206.83%2018.546%208.42%209.875%2017.092%205.454%2012.67%207.046%2011.08%27%20transform%3D%27translate(-5%20-6)%27/%3E%3C/svg%3E');
      background-size: 12px 12px;
      background-position: center;
      background-repeat: no-repeat;
    }

    .button {
      display: inline-block;
      text-decoration: none;
      border-radius: 4px;
      background-color: ${vars.coreDarkGrey};
      color: ${vars.white};
      font-weight: ${vars.fontWeightBold};
      ${vars.fontSize3};
      padding: ${vars.spacingM} ${vars.spacingL};
      cursor: pointer;
    }

    input.mce_inline_error {
      border-color: #f81616 !important;
    }

    div.mce_inline_error {
      background-color: #f3e9e9;
      color: #2f2f46;
      font-weight: normal;
      border: 1px solid #ccc;
      padding: 10px;
    }

    #mce-success-response {
      color: green;
      font-weight: bold;
      margin: 10px 0px 30px;
      padding: 10px;
      background-color: #d4e6d4;
      border: 1px solid #cccccc;
    }
    .t-and-c {
      margin: 20px 0;
      font-size: 1.2rem;
    }

    #mce-error-response .newsletter-error {
      background: #f3e9e9;
      color: #2f2f46;
      padding: 2rem 1rem;
      margin: 0 0 2rem 0;
      border: 1px solid #f81616 !important;
    }
  }
`;
